import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-onboarding-question-view',
  templateUrl: './question-view.component.html',
  styleUrls: ['./question-view.component.scss'],
  standalone: false
})
export class QuestionViewComponent {

  @Input() question!: string;
  @Input() info!: string;
  @Input() options!: string[];
  @Output() nextClicked: EventEmitter<any> = new EventEmitter<any>();

  selectedOption?: string;
  submitted: boolean = false;

  constructor() {}

  handleNextClick() {
    this.submitted = true;
    if (this.selectedOption) {
      this.nextClicked.emit(this.selectedOption);
    }
  }

  selectedOptionsChanged(selectedOptions: string[]) {
    this.selectedOption = selectedOptions[0];
  }
}
